var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.galleryView
      ? _c("div", { staticClass: "gallery gallery-sm" }, [
          _c(
            "div",
            [
              _vm._l(_vm.items, function(item) {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "thumbnail",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openItem(item)
                        }
                      }
                    },
                    [
                      _vm.PermissionDelete
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger media-delete",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.remove(item.id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 2
                        ? [
                            _c("img", {
                              staticClass: "thumbnail-image",
                              staticStyle: { "max-width": "200px" },
                              attrs: { src: _vm.getThumbnailUrl(item) }
                            })
                          ]
                        : item.type === 1
                        ? [_vm._m(0, true)]
                        : item.type === 3
                        ? [_vm._m(1, true)]
                        : item.type === 5
                        ? [_vm._m(2, true)]
                        : [_vm._m(3, true)],
                      _vm._v(" "),
                      _c("p", { staticClass: "thumbnail-text" }, [
                        _vm._v(_vm._s(item.Filename))
                      ])
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.listView
      ? _c("table", { staticClass: "table table-borderless table-media" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "td-medium" }, [
                _vm._v(_vm._s(_vm.$t("txtFileName")))
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "td-medium" }, [
                _vm._v(" " + _vm._s(_vm.$t("txtFileType")))
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "td-medium" }, [
                _vm._v(" " + _vm._s(_vm.$t("txtFileSize")))
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "td-small" }, [
                _vm._v(" " + _vm._s(_vm.$t("txtFileModified")))
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "actions one" })
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item) {
              return _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.application.preview.open(item.id)
                        }
                      }
                    },
                    [
                      item.type === "Audio"
                        ? _c("i", { staticClass: "fas fa-volume-up" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Document"
                        ? _c("i", { staticClass: "fas fa-file-alt" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Image"
                        ? _c("i", { staticClass: "fas fa-image" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Video"
                        ? _c("i", { staticClass: "fas fa-video" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Resource"
                        ? _c("i", { staticClass: "fas fa-box-open" })
                        : _vm._e(),
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.filename) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.contentType))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.sizePrettyPrint))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDateTimeSeconds(item.lastModified)))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "actions one" }, [
                  _vm.PermissionDelete
                    ? _c(
                        "a",
                        {
                          staticClass: "danger",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.remove(item.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-trash" })]
                      )
                    : _vm._e()
                ])
              ])
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-file-alt fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-film fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-box-open fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-file" }),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-file fa-3x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }